import { connect } from 'react-redux';

import { Complaint, IComplaintProps } from './index';
import { resetComplaintState } from '../../../../store/complaint';
import { getComplaints } from '../../../../store/complaint/get_complaints';
import { closeFeedbackComplaintPopup } from '../../../actions/feedback';

import type { DispatchReduxAction, IState } from '../../../../store';

export type TStoreFields = Pick<
  IComplaintProps,
  'offer' | 'complaints' | 'isComplaintAdded' | 'isLoading' | 'errorMessage' | 'isOpen' | 'sendFeedbackStatus'
>;
export type TActions = Pick<IComplaintProps, 'getComplaints' | 'resetComplaintState' | 'onClose'>;

export function mapStateToProps(state: IState): TStoreFields {
  const { status } = state.complaintFeedbackFrom;

  return {
    offer: state.offerData.offer,
    complaints: state.complaint.complaints,
    errorMessage: state.complaint.errorMessage,
    isComplaintAdded: state.complaint.isComplaintAdded,
    isLoading: state.complaint.isLoading,
    isOpen: state.feedback.isComplaintPopupOpened,
    sendFeedbackStatus: status,
  };
}

export function mapDispatchToProps(dispatch: DispatchReduxAction): TActions {
  return {
    getComplaints: (category: number) => dispatch(getComplaints(category)),
    onClose: () => dispatch(closeFeedbackComplaintPopup()),
    resetComplaintState: () => dispatch(resetComplaintState()),
  };
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const FeedbackComplaintPopupContainer = connect<TStoreFields, TActions, any>(
  mapStateToProps,
  mapDispatchToProps,
)(Complaint);
